import type { NewsContent } from "../types";
import { renderSectionHeader } from "./section-header";

export function renderNews(news: NewsContent): string {
  const cards = news.items
    .map(
      (n, i) => `
      <a class="news-card${n.featured ? " featured" : ""}" href="${n.href}" data-reveal style="--i:${i}">
        <span class="news-cat">${n.category}</span>
        <h3>${n.title}</h3>
        <div class="news-meta">
          <time>${n.date}</time>
          <span class="news-arrow" aria-hidden="true">→</span>
        </div>
      </a>`,
    )
    .join("");

  return `
    <section class="section" id="${news.id}">
      ${renderSectionHeader(news.header)}
      <div class="news-grid${news.items.length === 1 ? " news-grid--single" : ""}">${cards}</div>
      <div class="news-more" data-reveal>
        <a class="btn ghost" href="${news.moreHref}">${news.moreLabel}</a>
      </div>
    </section>`;
}
